import React, {  } from "react";
import { Flex, Input } from "@fluentui/react-northstar";
import ClearInputIcon from "shared/components/clearInputIcon/ClearInputIcon";

export interface IPhraseSearchInputProps {
    searchPhrase: string | undefined;
    onSearchPhraseChanged: (searchPhrase: string | undefined) => void;
    clearInputDisabled: boolean;
}

const PhraseSearchInput: React.FC<IPhraseSearchInputProps> = ({
    searchPhrase,
    onSearchPhraseChanged,
    clearInputDisabled
}) => {

    return (
        <Flex vAlign="center" fill style={{ width: "100%" }}>
            <Input
                value={searchPhrase}
                onChange={(e) => onSearchPhraseChanged((e.currentTarget as EventTarget & HTMLInputElement).value)}
                fluid
            />
            <ClearInputIcon
                disabled={clearInputDisabled}
                onClick={() => {
                    onSearchPhraseChanged("");
                }}
            />
        </Flex>
    );
};

export default PhraseSearchInput;
